import { Default, Detail,  List, Create } from "./views";
const Module = {
    name: "audiencedeliveries",
    defaultRoutePath: "/audiences/audiencedelivery",
    menuItemScope: "audience",
    menuItemName: "audiencedeliveries",

    routes: [
        {
            path: "/audiences/audiencedelivery",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
